import content from '@/content.json'

export const buildFAQSchema = () => {
  const mainEntity = content.faq.map((entry) => {
    return {
      '@type': 'Question',
      name: entry.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: entry.answer.join(''),
      },
    }
  })

  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    name: 'Roaming charges freqently asked questions',
    mainEntity: mainEntity,
  }
}
